// Utility function to format minutes into hours and minutes
export const formatMinutesToDuration = (totalMinutes: number): string => {
  const rounded = Math.round(totalMinutes);
  if (rounded === 0) return "0min";

  const hours = Math.floor(rounded / 60);
  const minutes = rounded % 60;

  if (hours === 0) return `${minutes}min`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}min`;
};

// Helper function to calculate duration in minutes - reused by calculateDurationBetweenDates
export const getDurationInMinutes = (startTime: string | null, endTime: string | null): number => {
  if (!startTime || !endTime) return 0;

  try {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const diffMs = end.getTime() - start.getTime();

    if (diffMs < 0) return 0;

    return Math.floor(diffMs / (1000 * 60));
  } catch {
    return 0;
  }
};

// Utility function to calculate duration between two datetime strings
export const calculateDurationBetweenDates = (
  startTime: string | null,
  endTime: string | null,
): string => {
  const diffMinutes = getDurationInMinutes(startTime, endTime);

  if (diffMinutes === 0) return "---";

  return formatMinutesToDuration(diffMinutes);
};

export const formatTimestamp = (timestamp: Date) => {
  return timestamp.toLocaleDateString("en-NL", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

// Utility function to format ISO date string to readable date and time
export const formatISOToReadableDate = (isoString: string | null): string => {
  if (!isoString) return "---";

  try {
    const date = new Date(isoString);
    return formatTimestamp(date);
    // Format as: "Dec 25, 14:30"
  } catch {
    return "---";
  }
};
